import _ from "lodash";

let csvw_url = "https://www.csvw.com";

let workspace50 = [
  {
    imgurl: "/u/cms/www/202110/092028257j0x.jpg",
    imgurlMobile: "/u/cms/www/202110/092028257j0x.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/092028241E6d.jpg",
    imgurlMobile: "/u/cms/www/202110/092028241E6d.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09202824P121.jpg",
    imgurlMobile: "/u/cms/www/202110/09202824P121.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09202826Ll2u.jpg",
    imgurlMobile: "/u/cms/www/202110/09202826Ll2u.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09202827cS31.jpg",
    imgurlMobile: "/u/cms/www/202110/09202827cS31.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09202827l06B.jpg",
    imgurlMobile: "/u/cms/www/202110/09202827l06B.jpg",
  },
  // {
  //   imgurl: "/u/cms/www/202110/092028285XI4.jpg",
  //   imgurlMobile: "/u/cms/www/202110/092028285XI4.jpg",
  // },
  {
    imgurl: "/u/cms/www/202110/09202830U0m7.jpg",
    imgurlMobile: "/u/cms/www/202110/09202830U0m7.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/092028294fXR.jpg",
    imgurlMobile: "/u/cms/www/202110/092028294fXR.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09202830B1W3.jpg",
    imgurlMobile: "/u/cms/www/202110/09202830B1W3.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/0920283291nX.jpg",
    imgurlMobile: "/u/cms/www/202110/0920283291nX.jpg",
  },
  // {
  //   imgurl: "/u/cms/www/202110/09202832Y30O.jpg",
  //   imgurlMobile: "/u/cms/www/202110/09202832Y30O.jpg",
  // },
  // {
  //   imgurl: "/u/cms/www/202110/09202832sjb0.jpg",
  //   imgurlMobile: "/u/cms/www/202110/09202832sjb0.jpg",
  // },
  {
    imgurl: "/u/cms/www/202110/09202833l7T6.jpg",
    imgurlMobile: "/u/cms/www/202110/09202833l7T6.jpg",
  },
  // {
  //   imgurl: "/u/cms/www/202110/092028344456.jpg",
  //   imgurlMobile: "/u/cms/www/202110/092028344456.jpg",
  // },
  // {
  //   imgurl: "/u/cms/www/202110/09202835p8ws.jpg",
  //   imgurlMobile: "/u/cms/www/202110/09202835p8ws.jpg",
  // },
  {
    imgurl: "/u/cms/www/202110/092028348ezd.jpg",
    imgurlMobile: "/u/cms/www/202110/092028348ezd.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09202837q91c.jpg",
    imgurlMobile: "/u/cms/www/202110/09202837q91c.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/092028370T9c.jpg",
    imgurlMobile: "/u/cms/www/202110/092028370T9c.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09202840K6ph.jpg",
    imgurlMobile: "/u/cms/www/202110/09202840K6ph.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/0920284071K8.jpg",
    imgurlMobile: "/u/cms/www/202110/0920284071K8.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/092028417K66.jpg",
    imgurlMobile: "/u/cms/www/202110/092028417K66.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09202842l0f0.jpg",
    imgurlMobile: "/u/cms/www/202110/09202842l0f0.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09202844Z193.jpg",
    imgurlMobile: "/u/cms/www/202110/09202844Z193.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09202849z7F5.jpg",
    imgurlMobile: "/u/cms/www/202110/09202849z7F5.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/092028438862.jpg",
    imgurlMobile: "/u/cms/www/202110/092028438862.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09202845PRU5.jpg",
    imgurlMobile: "/u/cms/www/202110/09202845PRU5.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09202846P301.jpg",
    imgurlMobile: "/u/cms/www/202110/09202846P301.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09202847M9R7.jpg",
    imgurlMobile: "/u/cms/www/202110/09202847M9R7.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/092028488bgc.jpg",
    imgurlMobile: "/u/cms/www/202110/092028488bgc.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/092028495V1n.jpg",
    imgurlMobile: "/u/cms/www/202110/092028495V1n.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09202850Y341.jpg",
    imgurlMobile: "/u/cms/www/202110/09202850Y341.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09202852CE6s.jpg",
    imgurlMobile: "/u/cms/www/202110/09202852CE6s.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09202853M3Wg.jpg",
    imgurlMobile: "/u/cms/www/202110/09202853M3Wg.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09202852kW9M.jpg",
    imgurlMobile: "/u/cms/www/202110/09202852kW9M.jpg",
  },
].map((item) => {
  return {
    imgurl: `${csvw_url}${item.imgurl}`,
    imgurlMobile: `${csvw_url}${item.imgurlMobile}`,
  };
});

let workspace50copy = _.cloneDeep(workspace50);
workspace50copy.push({
  imgurl: `${csvw_url}/u/cms/www/202110/11151953k0ae.jpg`,
  imgurlMobile: `${csvw_url}/u/cms/www/202110/11151953k0ae.jpg`,
});
console.log(workspace50, workspace50copy);

let workspace51 = [
  {
    imgurl: "/u/cms/www/202110/092018071q5z.jpg",
    imgurlMobile: "/u/cms/www/202110/092018071q5z.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09201809mPY2.jpg",
    imgurlMobile: "/u/cms/www/202110/09201809mPY2.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/092018098ZK8.jpg",
    imgurlMobile: "/u/cms/www/202110/092018098ZK8.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09201811k3Ly.jpg",
    imgurlMobile: "/u/cms/www/202110/09201811k3Ly.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09201812i9e2.jpg",
    imgurlMobile: "/u/cms/www/202110/09201812i9e2.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09201813E9o5.jpg",
    imgurlMobile: "/u/cms/www/202110/09201813E9o5.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/092018174A2L.jpg",
    imgurlMobile: "/u/cms/www/202110/092018174A2L.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09201817iiu7.jpg",
    imgurlMobile: "/u/cms/www/202110/09201817iiu7.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09201817tYBw.jpg",
    imgurlMobile: "/u/cms/www/202110/09201817tYBw.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09201819413a.jpg",
    imgurlMobile: "/u/cms/www/202110/09201819413a.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09201820j9Z4.jpg",
    imgurlMobile: "/u/cms/www/202110/09201820j9Z4.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/0920181903eI.jpg",
    imgurlMobile: "/u/cms/www/202110/0920181903eI.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/092018193G30.jpg",
    imgurlMobile: "/u/cms/www/202110/092018193G30.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/0920182014c2.jpg",
    imgurlMobile: "/u/cms/www/202110/0920182014c2.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09201822npAj.jpg",
    imgurlMobile: "/u/cms/www/202110/09201822npAj.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09201822B20K.jpg",
    imgurlMobile: "/u/cms/www/202110/09201822B20K.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/0920182223U4.jpg",
    imgurlMobile: "/u/cms/www/202110/0920182223U4.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09201824Syyo.jpg",
    imgurlMobile: "/u/cms/www/202110/09201824Syyo.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/0920182436I3.jpg",
    imgurlMobile: "/u/cms/www/202110/0920182436I3.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/092018241E11.jpg",
    imgurlMobile: "/u/cms/www/202110/092018241E11.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09201826m7dj.jpg",
    imgurlMobile: "/u/cms/www/202110/09201826m7dj.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09201826O978.jpg",
    imgurlMobile: "/u/cms/www/202110/09201826O978.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/0920182779P0.jpg",
    imgurlMobile: "/u/cms/www/202110/0920182779P0.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/092018287P29.jpg",
    imgurlMobile: "/u/cms/www/202110/092018287P29.jpg",
  },
].map((item) => {
  return {
    imgurl: `${csvw_url}${item.imgurl}`,
    imgurlMobile: `${csvw_url}${item.imgurlMobile}`,
  };
});

let workspace51copy = _.cloneDeep(workspace51);
workspace51copy.push({
  imgurl: `${csvw_url}/u/cms/www/202110/111504164R81.jpg`,
  imgurlMobile: `${csvw_url}/u/cms/www/202110/111504164R81.jpg`,
});
console.log(workspace51, workspace51copy);

let workspace52 = [
  {
    imgurl: "/u/cms/www/202110/092046160f8C.jpg",
    imgurlMobile: "/u/cms/www/202110/092046160f8C.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09204616891R.jpg",
    imgurlMobile: "/u/cms/www/202110/09204616891R.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09204617Trd3.jpg",
    imgurlMobile: "/u/cms/www/202110/09204617Trd3.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/092046178xc9.jpg",
    imgurlMobile: "/u/cms/www/202110/092046178xc9.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09204619W79p.jpg",
    imgurlMobile: "/u/cms/www/202110/09204619W79p.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/0920461822Wk.jpg",
    imgurlMobile: "/u/cms/www/202110/0920461822Wk.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/092046196Czs.jpg",
    imgurlMobile: "/u/cms/www/202110/092046196Czs.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/092046192377.jpg",
    imgurlMobile: "/u/cms/www/202110/092046192377.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/092046227K9F.jpg",
    imgurlMobile: "/u/cms/www/202110/092046227K9F.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09204620WU79.jpg",
    imgurlMobile: "/u/cms/www/202110/09204620WU79.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09204622YgGV.jpg",
    imgurlMobile: "/u/cms/www/202110/09204622YgGV.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09204621qa96.jpg",
    imgurlMobile: "/u/cms/www/202110/09204621qa96.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/092046228B59.jpg",
    imgurlMobile: "/u/cms/www/202110/092046228B59.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/0920462388jD.jpg",
    imgurlMobile: "/u/cms/www/202110/0920462388jD.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09204623HD63.jpg",
    imgurlMobile: "/u/cms/www/202110/09204623HD63.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/092046231719.jpg",
    imgurlMobile: "/u/cms/www/202110/092046231719.jpg",
  },
  // {
  //   imgurl: "/u/cms/www/202110/09204624CcuA.jpg",
  //   imgurlMobile: "/u/cms/www/202110/09204624CcuA.jpg",
  // },
  // {
  //   imgurl: "/u/cms/www/202110/092046256vit.jpg",
  //   imgurlMobile: "/u/cms/www/202110/092046256vit.jpg",
  // },
  // {
  //   imgurl: "/u/cms/www/202110/092046253e8j.jpg",
  //   imgurlMobile: "/u/cms/www/202110/092046253e8j.jpg",
  // },
  // {
  //   imgurl: "/u/cms/www/202110/092046260o62.jpg",
  //   imgurlMobile: "/u/cms/www/202110/092046260o62.jpg",
  // },
  // {
  //   imgurl: "/u/cms/www/202110/09204626qbZ5.jpg",
  //   imgurlMobile: "/u/cms/www/202110/09204626qbZ5.jpg",
  // },
  {
    imgurl: "/u/cms/www/202110/09204626i40G.jpg",
    imgurlMobile: "/u/cms/www/202110/09204626i40G.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09204627XFPI.jpg",
    imgurlMobile: "/u/cms/www/202110/09204627XFPI.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/092046282es3.jpg",
    imgurlMobile: "/u/cms/www/202110/092046282es3.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09204628Co0W.jpg",
    imgurlMobile: "/u/cms/www/202110/09204628Co0W.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09204628t940.jpg",
    imgurlMobile: "/u/cms/www/202110/09204628t940.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09204629oA76.jpg",
    imgurlMobile: "/u/cms/www/202110/09204629oA76.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09204630AcXc.jpg",
    imgurlMobile: "/u/cms/www/202110/09204630AcXc.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09204629Mg6e.jpg",
    imgurlMobile: "/u/cms/www/202110/09204629Mg6e.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/0920462987c1.jpg",
    imgurlMobile: "/u/cms/www/202110/0920462987c1.jpg",
  },
].map((item) => {
  return {
    imgurl: `${csvw_url}${item.imgurl}`,
    imgurlMobile: `${csvw_url}${item.imgurlMobile}`,
  };
});

// 数组分组
/**
 * arr 数组
 * number 每组几个
 */
function arrayGroup(arr, number) {
  let newArr = [];
  let length = arr.length;
  // 分成几组
  let group = Math.ceil(length / number);
  for (let i = 0; i < group; i++) {
    let arrItem = [];
    for (let j = 0; j < number; j++) {
      let item;
      let index = i * number + j;
      if (index < length) {
        item = `${arr[index].imgurl}`;
      } else {
        item = "";
      }
      arrItem.push(item);
    }
    newArr.push(arrItem);
  }
  return newArr;
}

export default {
  // 列表车型
  workspace5: [
    {
      iconurl: `${csvw_url}/u/cms/www/202109/301203088Pv7.png`,
      title: "ID.3潮趣太空舱 深圳欢乐港湾",
      content:
        "ID.3潮趣展在科技之都——深圳开展，ID.3将自身的潮趣造型与乐趣满满的科技氛围，与当地的独特风格完美结合，打造又一引爆全网的网红打卡圣地，彰显乐趣纯电跨界车潮酷型格。ID.3打破传统形式，用充满科幻感的太空舱概念与多品牌联名活动，让潮人全方面体验ID.3的潮趣、智趣、驾趣三趣合一。",
      // imgurl: [`${csvw_url}/u/cms/www/202110/09205351z5T4.png`],
      imgurl: [`${csvw_url}/u/cms/www/202311/23103421Le6F.jpg`],
      imgurl2: workspace50.map((item) => item.imgurl),
      imgurl2Group: arrayGroup(workspace50, 5),
      // imgurlMobile: [`${csvw_url}/u/cms/www/202110/092055262PBC.jpg`],
      imgurlMobile: [`${csvw_url}/u/cms/www/202311/2310351046tJ.jpg`],
      imgurlMobile2: workspace50copy.map((item) => item.imgurlMobile),
      imgurlMobile2Group: arrayGroup(workspace50copy, 3),
      // videourl: [`${csvw_url}/u/cms/www/202110/0920155347KO.mp4`],
      videourl: [],
      url:
        "https://www.csvw.com/csvw-website/news/dz-brand-news.html?newsid=3150",
    },
    {
      iconurl: `${csvw_url}/u/cms/www/202109/301203081v80.png`,
      title: "ID.3潮趣麻将馆 成都万象城",
      content:
        "ID.3成都潮趣麻将馆，以熊猫打麻将为主题，融入众多ID.3趣味元素，是喜爱新事物的潮人们不容错过的打卡地。入口首先映入眼帘的便是脚下的压感AR-HUD通道，随着你的步伐，两侧AR-HUD随动产生呼吸灯效果，就如该功能的用途一样，将行车信息及路况导航信息投射在前挡风玻璃上并与前方道路视觉融合，提升驾驶趣味性和科幻感，为你打开乐趣世界之门。",
      imgurl: [`${csvw_url}/u/cms/www/202110/09205351916x.png`],
      imgurl2: workspace51copy.map((item) => item.imgurl),
      imgurl2Group: arrayGroup(workspace51copy, 5),
      imgurlMobile: [`${csvw_url}/u/cms/www/202110/09205527m862.jpg`],
      imgurlMobile2: workspace51copy.map((item) => item.imgurlMobile),
      imgurlMobile2Group: arrayGroup(workspace51, 3),
      videourl: [`${csvw_url}/u/cms/www/202110/09204238Ys0b.mp4`],
      url: "https://mp.weixin.qq.com/s/Gmjw6CMGAZjHYVwx7r361A",
    },
    {
      iconurl: `${csvw_url}/u/cms/www/202109/301203081v80.png`,
      title: "ID.3白色潮趣展 上海",
      content:
        "ID.3白色潮趣展在上海五角场合生汇ID.Store X与徐汇绿地缤纷城的ID.Store开展！由ID.3 Logo、AR-HUD标志以及ID家族风格的白Tee、潮鞋、帽子等组成的装置艺术，可直观地体验ID.3带来的跨界潮趣。以ID.3实车为主角的沉浸剧场，可欣赏三面大屏呈现的白色潮品快剪视频，体验ID.3皎月金星皮肤包的潮趣，实地解锁大片姿势，还可以直观地看到ID车型的构造配合讲解视频，能够更深入地了解ID车型。",
      // imgurl: [`${csvw_url}/u/cms/www/202110/09205351S358.png`],
      imgurl: [`${csvw_url}/u/cms/www/202311/2311102218XK.jpg`],
      imgurl2: workspace52.map((item) => item.imgurl),
      imgurl2Group: arrayGroup(workspace52, 5),
      // imgurlMobile: [`${csvw_url}/u/cms/www/202110/0920552575b9.jpg`],
      imgurlMobile: [`${csvw_url}/u/cms/www/202311/23111117743V.jpg`],
      imgurlMobile2: workspace52.map((item) => item.imgurlMobile),
      imgurlMobile2Group: arrayGroup(workspace52, 3),
      // videourl: [`${csvw_url}/u/cms/www/202110/0920155781GO.mp4`],
      videourl: [],
      url: "https://mp.weixin.qq.com/s/wHLaLIIrIZt8gc2fGv9AxA",
    },
  ],
  // 现场花絮
};
